/**
 * @generated SignedSource<<cf02677d7f622a15525c73be98957d67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startOfDay"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTime"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "terminalId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeRange"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "terminalId"
  }
],
v5 = {
  "kind": "Variable",
  "name": "startTime",
  "variableName": "startTime"
},
v6 = {
  "kind": "Variable",
  "name": "timeRange",
  "variableName": "timeRange"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "kind": "Literal",
  "name": "numberOfDepartures",
  "value": 1
},
v9 = {
  "kind": "Literal",
  "name": "omitCanceled",
  "value": true
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "serviceDay",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "stopRoutes_TerminalPageMapContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Stop",
        "kind": "LinkedField",
        "name": "station",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "startOfDay",
                "variableName": "startOfDay"
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "TerminalPageMapContainer_station"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "stopRoutes_TerminalPageMapContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Stop",
        "kind": "LinkedField",
        "name": "station",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "platformCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "desc",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vehicleMode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gtfsId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "types",
                "value": [
                  "STOP",
                  "ROUTES"
                ]
              }
            ],
            "concreteType": "Alert",
            "kind": "LinkedField",
            "name": "alerts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alertEffect",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alertSeverityLevel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "effectiveStartDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "effectiveEndDate",
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": "alerts(types:[\"STOP\",\"ROUTES\"])"
          },
          {
            "alias": "serviceToday",
            "args": [
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "kind": "Variable",
                "name": "startTime",
                "variableName": "startOfDay"
              },
              {
                "kind": "Literal",
                "name": "timeRange",
                "value": 86400
              }
            ],
            "concreteType": "Stoptime",
            "kind": "LinkedField",
            "name": "stoptimesWithoutPatterns",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "concreteType": "Stoptime",
            "kind": "LinkedField",
            "name": "stoptimesWithoutPatterns",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4739246e6e64d61b9305c53f8cfd6c09",
    "id": null,
    "metadata": {},
    "name": "stopRoutes_TerminalPageMapContainer_Query",
    "operationKind": "query",
    "text": "query stopRoutes_TerminalPageMapContainer_Query(\n  $terminalId: String!\n  $startOfDay: Long!\n  $startTime: Long!\n  $timeRange: Int!\n) {\n  station(id: $terminalId) {\n    ...TerminalPageMapContainer_station_1EBKbJ\n    id\n  }\n}\n\nfragment TerminalPageMapContainer_station_1EBKbJ on Stop {\n  lat\n  lon\n  platformCode\n  name\n  code\n  desc\n  vehicleMode\n  locationType\n  gtfsId\n  alerts(types: [STOP, ROUTES]) {\n    alertEffect\n    alertSeverityLevel\n    effectiveStartDate\n    effectiveEndDate\n    id\n  }\n  serviceToday: stoptimesWithoutPatterns(startTime: $startOfDay, timeRange: 86400, numberOfDepartures: 1, omitCanceled: true) {\n    serviceDay\n  }\n  stoptimesWithoutPatterns(startTime: $startTime, timeRange: $timeRange, numberOfDepartures: 1, omitCanceled: true) {\n    serviceDay\n  }\n}\n"
  }
};
})();

node.hash = "fb49b6f7e2d29b49776acc6e12a226d4";

export default node;
